import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles';
import ReactTooltip from 'react-tooltip';
import MediaQuery from 'react-responsive';
import EstimatorListModal from './estimatorListModal';

class EstimatorCoveredZips extends React.Component {
  constructor(props) {
    super(props);
    this.state = { modalActive: false, chosenZip: '' };
  }

  handleZipClick = zip => (this.setState({ modalActive: !this.state.modalActive, chosenZip: zip }));
  toggleModal = () => (this.setState({ modalActive: !this.state.modalActive }));

  hasSharedZip = (zip) => {
    const { shared_zip_map } = this.props;
    return shared_zip_map[zip] > 1;
  };

  isEstimator = () => this.props.role === 'estimator';

  renderContent = () => {
    const { covered_zip_codes = [], shared_zip_map } = this.props;
    if (!covered_zip_codes || !Array.isArray(covered_zip_codes) || !covered_zip_codes.length) return 'N/A';
    // Used in a hack to remove trailing comma
    const last = covered_zip_codes.length - 1;
    const content = covered_zip_codes.map((zip, i) => {
      if (this.hasSharedZip(zip)) {
        return (<span key={zip} className={styles.zipWrapper}>
          {this.isEstimator() ? zip : (<button
            key={zip}
            data-tip
            data-for={`zipToolTip_${zip}`}
            className={styles.zipBtn}
            type="button"
            onClick={() => this.handleZipClick(zip)}
          >{zip}</button>)}
          {i < last && ', '}
          <MediaQuery minWidth={400}>
            <ReactTooltip id={`zipToolTip_${zip}`} place="top" effect="solid">
              {shared_zip_map[zip] - 1} other estimator(s) cover this zip code.
            </ReactTooltip>
          </MediaQuery>
        </span>);
      }
      return (<span className={styles.zipWrapper} key={zip}>{zip}{i < last && ', '}</span>);
    });
    return content;
  }

  render = () => {
    const { estimator } = this.props;
    const { chosenZip, modalActive } = this.state;
    return (<div className={styles.zipContainer}>
      {this.renderContent()}
      {!this.isEstimator() && modalActive && <EstimatorListModal
        estimator={estimator}
        zipCode={chosenZip}
        show={modalActive}
        cancel={this.toggleModal}
        dismiss={this.toggleModal}
      />}
    </div>);
  }
}

EstimatorCoveredZips.propTypes = {
  covered_zip_codes: PropTypes.array,
  shared_zip_map: PropTypes.object,
  estimator: PropTypes.object,
  role: PropTypes.string,
};

export default EstimatorCoveredZips;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/estimators/components/estimatorCoveredZips.jsx